<script setup lang="ts">
import { useToast } from '@/stores/toastStore'

interface Emit {
  (e: 'update:modelValue', value: boolean): void
}

interface Props {
  modelValue: boolean
  code: number
  message: string
  timeout?: number
  link?: string
  linkText?: string
  timer?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  timeout: 3000,
})

const emit = defineEmits<Emit>()

const useToastStore = useToast()

const handleModelChange = (value: boolean) => {
  emit('update:modelValue', value)
}

const color = ref()
const icon = ref()

const location = 'top end'
const variant = 'flat'

const handleChange = () => {
  const statusCode = props.code
  if (statusCode >= 200 && statusCode < 300) {
    color.value = 'success'
    icon.value = 'tabler-check'
  }
  else if (statusCode >= 400) {
    color.value = 'error'
    icon.value = 'tabler-circle-off'
  }
  else {
    color.value = 'info'
    icon.value = 'tabler-info-circle'
  }
}

watch(
  () => props.modelValue,
  () => {
    if (!props.modelValue)
      useToastStore.reset()
    else
      handleChange()
  },
)
</script>

<template>
  <VSnackbar
    :model-value="props.modelValue"
    :location="location"
    :variant="variant"
    :color="color"
    :timeout="timeout"
    :timer="props.timer"
    icon="tabler-school"
    @update:model-value="handleModelChange(!modelValue)"
    @click="handleModelChange(!modelValue)"
  >
    <p class="mb-0">
      <VIcon
        class="icon-snackbar"
        dark
        large
        :icon="icon"
      />
      {{ message }}
    </p>
    <template
      v-if="link"
      #actions
    >
      <VBtn
        variant="flat"
        color="success"
        class="mx-2"
        :to="link"
      >
        {{ linkText }}
      </VBtn>
    </template>
  </VSnackbar>
</template>

<style scoped>
.icon-snackbar {
  vertical-align: bottom;
  margin-right: 0.5rem;
}
.link-snackbar {
  text-decoration: underline;
  margin-left: 0.5rem;
}
</style>
